import DOMPurify from 'dompurify';

import translate from 'utils/translate';

const escapeHtml = (value='') => {
  return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
};

const formatPlainTextAsHtml = (value='') => {
  const formattedNewlines = value.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

  if (!formattedNewlines) {
    return '';
  }

  const lines = formattedNewlines.split('\n');
  const htmlLines = lines
      .map((line) => {
        return `<div>${line ? escapeHtml(line) : '<br />'}</div>`;
      });
  const html = htmlLines.join('');

  return html;
};

const sanitizeHtml = (value='') => {
  return DOMPurify.sanitize(value, {
    ADD_ATTR: ['target'],
    USE_PROFILES: {html: true},
  });
};

const buildReplyEmailHtml = ({message='', replyDraft=null, messageIsHtml=false, showQuotedReply=false}) => {
  if (!replyDraft) {
    return messageIsHtml ?
      sanitizeHtml(message) || undefined :
      undefined;
  }

  if (showQuotedReply) {
    const replyBodyHtml = messageIsHtml ?
      sanitizeHtml(message) :
      formatPlainTextAsHtml(message);
    const quotedHtml = replyDraft.quotedHtml ?
      sanitizeHtml(replyDraft.quotedHtml) :
      formatPlainTextAsHtml(replyDraft.quotedText || '');
    const replyHeaderFallback = translate('en', 'client.ClientDetail.Correspondance.Correspondance.ReplyBuilder.HeaderFallback');

    return [
      '<div dir="ltr">',
      replyBodyHtml || '<div><br /></div>',
      '</div>',
      '<br />',
      '<div class="gmail_quote gmail_quote_container">',
      `<div dir="ltr" class="gmail_attr">${escapeHtml(replyDraft.replyHeader || replyHeaderFallback)}<br /></div>`,
      // Mirror a Gmail-style quoted section so the feed renders a familiar reply layout.
      `<blockquote class="gmail_quote" style="margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex">${quotedHtml}</blockquote>`,
      '</div>',
    ].join('');
  }

  if (messageIsHtml) {
    return sanitizeHtml(message) || undefined;
  }

  return formatPlainTextAsHtml(message) || undefined;
};

export default buildReplyEmailHtml;
